
  import {Component, Vue} from "vue-property-decorator";
  import AppDialog from "@/modules/Popup/components/AppDialog.vue";
  import FormBuilderField from "@/modules/FormBuilder/components/FormBuilderField.vue";
  import {IAppState} from "@/interfaces/app-state.interface";
  import CorpForm from "@/modules/Corps/components/corpPopup/CorpForm.vue";
  import {ICorp} from "@/modules/Corps/interfaces/corp.interface";
  import AccountsTable from "@/modules/Profile/components/accounts/AccountsTable.vue";
  import {IAuth} from "@/modules/Auth/interfaces/auth.interface";
  import CorpEventsLog from "@/modules/Corps/components/corpPopup/CorpEventsLog.vue";

  @Component({
    components: {
      CorpEventsLog,
      CorpForm,
      AccountsTable,
      AppDialog,
      FormBuilderField,
    }
  })
  export default class CorpPopup extends Vue {
    $refs: any;
    currentPopup = { blockName: 'allPages', dialogName: 'corpPopup' };
    createMode = false;
    activeTab: ICorp.CorpPopupTab = ICorp.CorpPopupTab.Form;

    get storeState(): IAppState { return this.$store.state; }
    get userAccess(): IAuth.UserAccess { return this.storeState.auth.userAccess; }
    get payloadPopup() { return this.$store.getters['dialog/getPopupPayload'](this.currentPopup); }

    get tabs() {
      let dataTabs: any[] = [
        {
          label: 'Карточка',
          name: ICorp.CorpPopupTab.Form,
          componentName: 'CorpForm',
          changeTabAction: true,
        },
      ];
      if (!this.createMode && this.userAccess.scUserPersons) {
        dataTabs.push(
          {
            label: 'Аккаунты',
            name: ICorp.CorpPopupTab.Accounts,
            componentName: 'AccountsTable',
            props: {
              corpId: this.payloadPopup.corpId,
              corpName: this.payloadPopup.corpName,
              fromCorp: true,
            }
          },
        );
      }
      if (!this.createMode) {
        dataTabs.push(
          {
            label: 'Журнал',
            name: ICorp.CorpPopupTab.Log,
            componentName: 'CorpEventsLog',
            props: {
              corpId: this.payloadPopup.corpId,
            }
          }
        );
      }
      return dataTabs;
    }

    created() {
      this.createMode = this.payloadPopup.createMode;
    }

    leaveTabAction(newTab, oldTab) {
      // let tab = this.tabs.find(item => item.name === oldTab);
      // if (tab && tab.changeTabAction) this.$refs[tab.componentName][0].changeTabAction();
    }

    async closeAction() {
      this.$store.commit('car/setProperty', { name: 'displayContent', value: true });
    }

    async onClose() {
      await this.closeAction();
      this.$refs.appDialog.onClose();
    }
  }
